"use client";

import React, { useEffect, useRef } from "react";
import { Layers } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EinfachZumErfolg() {
  const sectionRef = useRef<HTMLElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  const {
    ref: textRef,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!gridRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const moveX = (clientX - centerX) * 0.02;
      const moveY = (clientY - centerY) * 0.02;
      gridRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  // AI Builder submit handler
  useEffect(() => {
    (window as any).validateAiInput = () => {
      const textarea = document.getElementById("ai-builder-input") as HTMLTextAreaElement;
      if (!textarea) return;
      const input = textarea.value.trim();
      const msg = document.getElementById("validation-msg");
      const wrapper = textarea.closest(".ai-builder-wrapper");
      if (input.length >= 10 && msg) {
        msg.style.display = "none";
      }
      if (input.length > 0) {
        wrapper?.classList.add("has-value");
      } else {
        wrapper?.classList.remove("has-value");
      }
    };
    (window as any).handleAiBuilderSubmit = () => {
      const textarea = document.getElementById("ai-builder-input") as HTMLTextAreaElement;
      if (!textarea) return;
      const input = textarea.value.trim();
      const msg = document.getElementById("validation-msg");
      const maxMsg = document.getElementById("max-length-msg");
      if (input.length < 10) {
        if (msg) msg.style.display = "block";
        if (maxMsg) maxMsg.style.display = "none";
        return;
      }
      if (textarea.value.length > 2000) {
        if (maxMsg) maxMsg.style.display = "block";
        if (msg) msg.style.display = "none";
        return;
      }
      const data = JSON.stringify({
        initial_description: input
      });
      const encoded = encodeURIComponent(data);
      window.location.href = "https://dashboard.pagemaker24.ch/setup-onboarding/v2-ai-website-building?prefilledAiData=" + encoded + "&builder=wvc";
    };
  }, []);
  return <section data-section-id="10694" id="ki-website-generator-hero" ref={sectionRef} className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background py-20">
      {/* Grid background */}
      <div ref={gridRef} className="absolute inset-[-5%] w-[110%] h-[110%] pointer-events-none opacity-5 z-0" style={{
      backgroundImage: `
            linear-gradient(to right, var(--color-foreground) 1px, transparent 1px),
            linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)
          `,
      backgroundSize: "4rem 4rem",
      maskImage: "radial-gradient(circle at center, black 40%, transparent 80%)",
      WebkitMaskImage: "radial-gradient(circle at center, black 40%, transparent 80%)"
    }} aria-hidden="true" />
 
      {/* AI Builder CSS */}
      <style>{`
        @property --ai-builder-percent1 { syntax: "<percentage>"; inherits: true; initial-value: 68%; }
        @property --ai-builder-percent2 { syntax: "<percentage>"; inherits: true; initial-value: 81%; }
        @property --ai-builder-percent3 { syntax: "<percentage>"; inherits: true; initial-value: 94%; }
        @property --ai-builder-percent4 { syntax: "<percentage>"; inherits: true; initial-value: 100%; }
        @property --ai-builder-angle { syntax: "<angle>"; inherits: true; initial-value: 0turn; }
        @keyframes ai-builder-spin { 100% { --ai-builder-angle: 2turn; } }
        .ai-builder-wrapper {
          position: relative; width: 100%; max-width: 624px; margin: 0 auto;
          border-radius: 24px;
          box-shadow: 0 4px 8px 0 rgba(20,21,31,0.10), 0 2px 4px 0 rgba(20,21,31,0.06);
        }
        .ai-builder-wrapper::before {
          content: " "; position: absolute; inset: -1px;
          border: 1px solid transparent; border-radius: inherit;
          background-image: conic-gradient(from var(--ai-builder-angle), rgba(51,57,241,0.2) var(--ai-builder-percent1), #3339F1 var(--ai-builder-percent2), #3339F1 var(--ai-builder-percent3), rgba(51,57,241,0.2) var(--ai-builder-percent4));
          background-origin: border-box;
          mask: linear-gradient(#000,#000) content-box, linear-gradient(#000,#000);
          -webkit-mask: linear-gradient(#000,#000) content-box, linear-gradient(#000,#000);
          mask-clip: content-box, border-box; -webkit-mask-clip: content-box, border-box;
          mask-composite: exclude; -webkit-mask-composite: xor;
          animation: ai-builder-spin 8s linear infinite;
          opacity: 1; transition: opacity 0.5s ease; pointer-events: none;
        }
        .ai-builder-wrapper:has(textarea:focus)::before,
        .ai-builder-wrapper.has-value::before {
          animation: none; background-image: none; background: #3339F1;
        }
        .ai-builder-textarea {
          display: flex; width: 100%; height: 160px;
          padding: 16px 100px 16px 16px;
          flex-direction: column; align-items: flex-start;
          position: relative; border: 1px solid transparent; border-radius: 24px;
          background: transparent; color: var(--color-foreground);
          font-size: 0.875rem; font-family: inherit; resize: none;
          box-sizing: border-box; outline: none;
        }
        .ai-builder-textarea::placeholder { color: var(--color-muted-foreground); }
        .ai-builder-submit-svg {
          position: absolute; bottom: 8px; right: 8px; cursor: pointer;
          opacity: 1; transition: opacity 0.3s ease, transform 0.2s;
          pointer-events: auto; z-index: 10;
        }
        .ai-builder-submit-svg:hover { transform: scale(1.1); }
        .ai-builder-submit-svg:active { transform: scale(1); }
        .ai-builder-submit-btn {
          position: absolute; bottom: 8px; right: 8px;
          padding: 8px 16px; border-radius: 32px;
          border: 1px solid transparent; background: #3339F1; color: #fff;
          font-size: 12px; font-weight: 400; line-height: 18px;
          cursor: pointer; opacity: 0; transition: opacity 0.3s ease;
          pointer-events: none; z-index: 10;
        }
        .ai-builder-wrapper:has(textarea:focus) .ai-builder-submit-svg,
        .ai-builder-wrapper.has-value .ai-builder-submit-svg {
          opacity: 0; pointer-events: none;
        }
        .ai-builder-wrapper:has(textarea:focus) .ai-builder-submit-btn,
        .ai-builder-wrapper.has-value .ai-builder-submit-btn {
          opacity: 1; pointer-events: auto; z-index: 100;
        }
      `}</style>
 
      {/* Content */}
      <div className="container relative z-10 px-4 md:px-6">
        <div ref={textRef} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-8 border border-primary/20">
            <Layers className="w-4 h-4" />
            <span>KI-Website-Generator</span>
          </div>
 
          {/* Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-foreground mb-8 leading-[1.1]">
            Ihre Profi-Website. In einem Nachmittag online
          </h1>
 
          {/* Subheading */}
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed font-normal">
            Beschreiben Sie Ihre Idee – unsere KI erstellt Ihre Website in
            Minuten. Hosting, Domain und Support aus einer Hand.
          </p>
 
          {/* AI Builder Form */}
          <div className="max-w-2xl mx-auto mb-6">
            <div className="ai-builder-wrapper">
              <textarea id="ai-builder-input" className="ai-builder-textarea" placeholder="Beschreiben Sie Ihre Geschäftsidee in ein paar Worten..." onInput={() => (window as any).validateAiInput?.()} />
              <svg className="ai-builder-submit-svg" onClick={() => (window as any).handleAiBuilderSubmit?.()} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z" fill="white" fillOpacity="0.4" />
                <rect width="36" height="36" rx="18" fill="#14151F" fillOpacity="0.5" />
                <path d="M18.0916 10.2549C18.0932 10.255 18.0948 10.2547 18.0964 10.2549C18.1162 10.2568 18.1356 10.2607 18.155 10.2637C18.1704 10.266 18.1857 10.2684 18.2009 10.2715C18.254 10.2821 18.3054 10.2972 18.3552 10.3154C18.3696 10.3207 18.384 10.3261 18.3982 10.332C18.4524 10.3546 18.5043 10.3813 18.5535 10.4121C18.5613 10.417 18.5692 10.4216 18.5769 10.4268C18.5915 10.4364 18.6049 10.4477 18.6189 10.458C18.6604 10.4887 18.7014 10.5221 18.739 10.5596L24.1238 15.9248C24.5372 16.3371 24.5388 17.0072 24.1267 17.4209C23.7145 17.8344 23.0444 17.8347 22.6306 17.4229L19.0505 13.8545V24.6934C19.0503 25.2771 18.5767 25.7507 17.9929 25.751C17.4089 25.751 16.9356 25.2773 16.9353 24.6934V13.8594L13.3728 17.4219C12.9597 17.8346 12.2897 17.8348 11.8767 17.4219C11.4638 17.0089 11.464 16.3388 11.8767 15.9258L17.2419 10.5605C17.3518 10.4507 17.4804 10.3708 17.6169 10.3193C17.6376 10.3115 17.6582 10.3034 17.6794 10.2969C17.8132 10.2559 17.9534 10.2417 18.0916 10.2549Z" fill="white" fillOpacity="0.4" />
              </svg>
              <button className="ai-builder-submit-btn" onClick={() => (window as any).handleAiBuilderSubmit?.()}>
                Website generieren
              </button>
              <p id="validation-msg" style={{
              position: "absolute",
              top: "100%",
              left: 0,
              fontSize: "0.75rem",
              color: "red",
              margin: "8px 0 0",
              display: "none"
            }}>
                Bitte mindestens 10 Zeichen eingeben.
              </p>
              <p id="max-length-msg" style={{
              position: "absolute",
              top: "100%",
              left: 0,
              fontSize: "0.75rem",
              color: "red",
              margin: "8px 0 0",
              display: "none"
            }}>
                Zeichenlimit erreicht.
              </p>
            </div>
          </div>
 
          {/* Builder features */}
          <div className="flex items-center justify-center gap-5 flex-wrap mb-6 text-sm text-muted-foreground">
            <span className="flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              WordPress Backend
            </span>
            <span className="flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Hosting & Domain inklusive
            </span>
            <span className="flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Kein Code nötig
            </span>
          </div>
 
          {/* Secondary link */}
          <div className="flex items-center justify-center text-sm">
            <a href="https://dashboard.pagemaker24.ch/sign-up" className="text-muted-foreground hover:text-foreground transition-colors underline underline-offset-4">
              Oder kostenlos registrieren
            </a>
          </div>
        </div>
      </div>
    </section>;
}